import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { getYear } from 'date-fns';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lbt-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss',
  standalone: false
})
export class LoginLayoutComponent implements OnInit, OnDestroy {
  protected readonly year = getYear(new Date());

  private readonly viewportMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  private readonly originalContent = this.viewportMeta?.content ?? '';

  ngOnInit() {
    if (this.viewportMeta) {
      this.viewportMeta.content = 'width=device-width, initial-scale=1, interactive-widget=resizes-content';
    }
  }

  ngOnDestroy() {
    if (this.viewportMeta) {
      this.viewportMeta.content = this.originalContent;
    }
  }
}
